import { render, staticRenderFns } from "./patientsPortalInfo.vue?vue&type=template&id=79476092&"
import script from "./patientsPortalInfo.vue?vue&type=script&lang=js&"
export * from "./patientsPortalInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports